module.exports = __webpack_public_path__ + "logo-extension-8872e8092942b38a67ea70f36815d994.svg";